import React from 'react';

import PropTypes from 'prop-types';

import { BlockContainer } from './css';
import BlockItem from './components/blockItem';

const Block = ({ data, filterString, fetchData }) => {
  // let filteredData = data.filter(({outlet}) => {
  //   return outlet && outlet.includes(filterString) && outlet !== null 
  // });
  // if (filterString)
  //   filteredData = data.filter(
  //     ({ outlet }) => {
  //      return outlet && outlet.includes(filterString) && outlet !== null}
  //   );
  let filteredData = data.filter(({outlet}) => {
    return outlet !== null
  });

  if (filterString)
    filteredData = data.filter(
      ({ outlet }) => { 
      return outlet && outlet.includes(filterString) && outlet !== null}
    );

  return (
    <BlockContainer>
      {filteredData.map(rowData => (
        <BlockItem data={rowData} fetchData={fetchData} />
      ))}
    </BlockContainer>
  );
};

Block.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      formTypes: PropTypes.shape({
        disableBrp: PropTypes.bool,
        disableReferral: PropTypes.bool,
        disableWireless: PropTypes.bool,
        disableWireline: PropTypes.bool
      })
    })
  ).isRequired,
  filterString: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Block;
